import { render, staticRenderFns } from "./Morningcall.vue?vue&type=template&id=14748b1c"
import script from "./Morningcall.vue?vue&type=script&lang=js"
export * from "./Morningcall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports